module.exports = __webpack_public_path__ + "static/media/zm.d04925e6.png";